/*
	s_cursor.js
*/

function refreshCursor () {
    if(window.innerWidth > 736) {
    	const cursor = document.getElementById('cursor');
    	if(!cursor) return;
        if(window.pos_y+window.scrollY < $("body").height()-21)
            document.getElementById('cursor').style.top = window.pos_y+window.scrollY+"px";
        document.getElementById('cursor').style.left = window.pos_x+"px";
    }
}